import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { getSvgStyles } from 'baseui/icon';
import { styled } from '../../../theme/utils.js';
import { Icon } from '../icon.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Svg = forwardRef((_a, ref) => {
  var _b = _a, { title, titleId } = _b, props = __objRest(_b, ["title", "titleId"]);
  return jsxs("svg", __spreadProps(__spreadValues({}, props), { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", ref, "aria-labelledby": titleId, children: [title ? jsx("title", { id: titleId, children: title }) : null, jsx("path", { fill: "currentColor", d: "M16.8425 2.50489L5.44531 20.5879L7.13729 21.6543L18.5345 3.57129L16.8425 2.50489Z" }), jsx("path", { fill: "currentColor", d: "M9.96972 9.01806V6.01806C9.96972 4.37506 8.63372 3.03906 6.99072 3.03906C5.34772 3.03906 4.01172 4.37606 4.01172 6.01806V9.01806C4.01172 10.6611 5.34772 11.9971 6.99072 11.9971C8.63372 11.9971 9.96972 10.6601 9.96972 9.01806ZM6.01172 9.01806V6.01806C6.01172 5.47806 6.45072 5.03906 6.99072 5.03906C7.53072 5.03906 7.96972 5.47806 7.96972 6.01806V9.01806C7.96972 9.55806 7.53072 9.99706 6.99072 9.99706C6.45072 9.99706 6.01172 9.55806 6.01172 9.01806Z" }), jsx("path", { fill: "currentColor", d: "M16.9907 12.0801C15.3477 12.0801 14.0117 13.4171 14.0117 15.0591V18.0591C14.0117 19.7021 15.3477 21.0381 16.9907 21.0381C18.6337 21.0381 19.9697 19.7021 19.9697 18.0591V15.0591C19.9697 13.4161 18.6337 12.0801 16.9907 12.0801ZM17.9697 18.0591C17.9697 18.5991 17.5307 19.0381 16.9907 19.0381C16.4507 19.0381 16.0117 18.6001 16.0117 18.0591V15.0591C16.0117 14.5191 16.4507 14.0801 16.9907 14.0801C17.5307 14.0801 17.9697 14.5191 17.9697 15.0591V18.0591Z" })] }));
});
const StyledSvg = styled(Svg, getSvgStyles);
const overrides = {
  Svg: {
    component: StyledSvg
  }
};
const IconPercent = forwardRef((props, ref) => jsx(Icon, __spreadValues({ ref, overrides }, props)));
IconPercent.displayName = "IconPercent";

export { IconPercent };
